import { isValidElement } from 'react';
import deepFilter from './deepFilter.js';
const onlyValid = (children) => deepFilter(children, (child) => isValidElement(child));
export default onlyValid;
//# sourceMappingURL=onlyValid.js.map